import { useState, useEffect } from "react";
import { ExternalLink, Maximize2, RefreshCw, AlertCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";

export default function SmartOrange() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const smartOrangeUrl = "https://smartorange.space/trp/sales";

  const openInNewWindow = () => {
    window.open(smartOrangeUrl, 'SmartOrange', 'width=1400,height=900,menubar=no,toolbar=no,location=no,status=no');
  };

  const openInNewTab = () => {
    window.open(smartOrangeUrl, '_blank');
  };

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const handleIframeError = () => {
    setLoading(false);
    setError(true);
  };

  // Check if iframe loaded content (timeout fallback)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 5000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="h-full flex flex-col" data-testid="smart-orange-page">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b bg-orange-500/10">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-orange-500 flex items-center justify-center">
            <span className="text-white font-bold text-lg">SO</span>
          </div>
          <div>
            <h1 className="text-xl font-light text-foreground">Smart Orange</h1>
            <p className="text-sm text-muted-foreground">Sales & CRM Dashboard</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => window.location.reload()}
            className="gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            Refresh
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={openInNewWindow}
            className="gap-2"
          >
            <Maximize2 className="w-4 h-4" />
            Pop-out Window
          </Button>
          <Button
            size="sm"
            onClick={openInNewTab}
            className="gap-2 bg-orange-500 text-white"
          >
            <ExternalLink className="w-4 h-4" />
            Open Smart Orange
          </Button>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 relative">
        {/* Loading overlay */}
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-background/80 z-10">
            <div className="flex flex-col items-center gap-3">
              <RefreshCw className="w-8 h-8 animate-spin text-orange-500" />
              <p className="text-sm text-muted-foreground">Loading Smart Orange...</p>
            </div>
          </div>
        )}

        {/* Iframe */}
        <iframe
          src={smartOrangeUrl}
          title="Smart Orange"
          className="absolute inset-0 w-full h-full border-0"
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          allow="fullscreen; clipboard-write; clipboard-read"
          referrerPolicy="no-referrer-when-downgrade"
        />

        {/* Fallback message if iframe doesn't work */}
        {!loading && (
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20">
            <Card className="bg-orange-500/10 border-orange-500/20">
              <CardContent className="p-3 flex items-center gap-3">
                <AlertCircle className="w-5 h-5 text-orange-500" />
                <span className="text-sm">
                  If the page doesn't load, click{" "}
                  <button 
                    onClick={openInNewTab}
                    className="font-semibold text-orange-500 hover:underline"
                  >
                    Open Smart Orange
                  </button>
                  {" "}to access it directly.
                </span>
              </CardContent>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
}
